import { Option } from '~/core/shared/types';

export enum MaritalStatus {
  Single = 'Single',
  Married = 'Married',
  Divorced = 'Divorced',
  Widowed = 'Widowed',
  DeFacto = 'De facto',
}

export const MARITAL_STATUS_OPTIONS: Option<string>[] = [
  {
    label: 'Single',
    value: MaritalStatus.Single,
  },
  {
    label: 'Married',
    value: MaritalStatus.Married,
  },
  {
    label: 'Divorced',
    value: MaritalStatus.Divorced,
  },
  {
    label: 'Widowed',
    value: MaritalStatus.Widowed,
  },
  {
    label: 'De facto',
    value: MaritalStatus.DeFacto,
  },
];
